frappe.provide("frappe.ui");

const default_statuses = {
	0: "Draft",
	1: "Submitted",
	2: "Cancelled",
};

frappe.ui.document_timeline = class DocumentTimeline {
	constructor(opts) {
		Object.assign(this, opts);
		this.wrapper = null;
		this.make();
		this.bind_to_frm();
	}

	bind_to_frm() {
		$(this.frm.wrapper).off("render_complete.document_timeline");
		$(this.frm.wrapper).on("render_complete.document_timeline", () => {
			this.make();
		});
	}

	async get_data() {
		this.data = await frappe.call({
			method: "frappe.utils.document_timeline.get_document_timeline",
			args: {
				document: this.frm.doc,
				configuration: this.config,
			},
		});
	}

	async make() {
		this.wrapper = $(this.frm.sidebar.sidebar).find(".dodock-document-timeline").get(0);
		if (!this.wrapper) return;

		const current_docname = this.frm.doc?.name;
		if (!current_docname) return;

		if (this.loading_docname === current_docname) {
			return;
		}

		try {
			this.loading_docname = current_docname;
			await this.get_data();

			if (this.frm.doc?.name !== current_docname) return;

			const content = this.data.message.map(async (doc) => {
				await frappe.model.with_doctype(doc.doctype);
				const linked_doc = await frappe.model.with_doc(doc.doctype, doc.docname);
				const status = __(
					doc.data.workflow_state ||
						doc.data.status ||
						default_statuses[doc.data.docstatus]
				);
				const indicator = frappe.get_indicator(
					linked_doc,
					doc.doctype,
					doc.data.workflow_state
				);

				return this.timeline_model(doc, status, indicator[1], this.is_current_doc(doc));
			});

			const resolved_content = await Promise.all(content);

			if (this.frm.doc?.name !== current_docname) return;

			const timeline = document.createElement("div");
			timeline.classList.add("new-timeline");
			timeline.innerHTML = `<h6 class="timeline-title">${__("Linked Transactions")}</h6>`;

			const timeline_items = document.createElement("div");
			timeline_items.classList.add("timeline-items");

			timeline.append(timeline_items);

			timeline_items.innerHTML = resolved_content.join("");

			this.wrapper.innerHTML = "";
			this.wrapper.append(timeline);
		} finally {
			if (this.loading_docname === current_docname) {
				this.loading_docname = null;
			}
		}
	}

	timeline_model(doc, status, color, current = false) {
		const card = frappe.ui.document_timeline.render_card(
			{ ...doc, date: frappe.datetime.str_to_user(doc.date), status, color },
			{ current, link: !current }
		);
		return `<div class="timeline-item">${card}</div>`;
	}

	/**
	 * A linked-document card: image, header (label + date), title, status badge and amount.
	 * Also used outside the form sidebar, e.g. by the calendar event popover.
	 *
	 * @param {object} entry { doctype, docname, title, image, date, header_label, status, color, amount, currency }.
	 * `date` is shown as given, so callers format it (a date, a time range, ...).
	 * @param {object} [opts] { current, link, show_avatar } — `show_avatar` shows the
	 * initials when there is no image.
	 * @returns {string}
	 */
	static render_card(entry, { current = false, link = true, show_avatar = false } = {}) {
		const escape = frappe.utils.escape_html;
		const title = entry.title || entry.docname;
		const avatar =
			entry.image || show_avatar
				? frappe.ui.avatar.html({
						image: entry.image,
						label: title,
						size: "2xl",
						shape: "square",
				  })
				: "";
		const status = entry.status
			? frappe.ui.badge.html({ label: entry.status, theme: entry.color, size: "sm" })
			: "";
		const amount = entry.amount ? format_currency(entry.amount, entry.currency) : "";

		const tag = link ? "a" : "div";
		const href = link
			? ` href="${frappe.utils.get_form_link(entry.doctype, entry.docname)}"`
			: "";
		return `<${tag} class="dodock-timeline-card ${current ? "is-current" : ""}"${href}>
				${avatar}
				<div class="dodock-timeline-card__details">
					<div class="dodock-timeline-card__header">
						<span>${escape(entry.header_label || __(entry.doctype))}</span>
						<span>${escape(entry.date || "")}</span>
					</div>
					<div class="dodock-timeline-card__title">${escape(title)}</div>
					<div class="dodock-timeline-card__body">
						${status}
						<span class="dodock-timeline-card__amount">${amount}</span>
					</div>
				</div>
			</${tag}>`;
	}

	is_current_doc(doc) {
		if (doc.doctype == this.frm.doctype && doc.docname == this.frm.doc.name) {
			return true;
		}

		return false;
	}
};

const _get_form_sidebar_extension = frappe.get_form_sidebar_extension;
frappe.get_form_sidebar_extension = () => {
	const ext = _get_form_sidebar_extension?.() || "";
	return `<div class="dodock-document-timeline"></div>${ext}`;
};

$(document).on("form-refresh", (_event, frm) => {
	frappe.provide("frappe.ui.document_timeline_settings");

	if (frappe.ui.document_timeline_settings[frm.doctype]) {
		if (!frm.document_timeline) {
			frm.document_timeline = new frappe.ui.document_timeline({
				frm: frm,
				config: frappe.ui.document_timeline_settings[frm.doctype],
			});
		} else {
			frm.document_timeline.config = frappe.ui.document_timeline_settings[frm.doctype];
			frm.document_timeline.make();
		}
	}
});
